import {AlertIcon, PlusIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {forwardRef} from 'react'
import styles from './AddIssueFieldButton.module.css'

export const AddIssueFieldButton = forwardRef<
  HTMLButtonElement,
  {
    anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
    inactive?: boolean | undefined
  }
>((props, ref) => {
  const {anchorProps, inactive = false} = props
  return (
    <div className={styles.container}>
      <Button
        leadingVisual={inactive ? AlertIcon : undefined}
        trailingVisual={!inactive ? PlusIcon : undefined}
        size="small"
        ref={ref}
        {...anchorProps}
        className={styles.button}
        inactive={inactive}
      >
        Add field
      </Button>
    </div>
  )
})
AddIssueFieldButton.displayName = 'AddIssueFieldButton'
